__turbopack_context__.v({
  "content": "fS_cPG_content",
  "optionInfo": "fS_cPG_optionInfo",
  "optionRow": "fS_cPG_optionRow",
  "totalHint": "fS_cPG_totalHint",
  "totalInfo": "fS_cPG_totalInfo",
  "totalRow": "fS_cPG_totalRow",
  "unitPrice": "fS_cPG_unitPrice",
});
